import jstz from "jstimezonedetect";
import _ from "underscore";

import api from "@/helpers/api";
import bus from "@/helpers/bus";

export default {
  state: {
    settings: {
      whitelisted_timezones: [],
      widget_enabled: false,
      initial_message: ""
    },
    mobileMode: false,
    robot: false
  },

  mutations: {
    setSettings(state, settings) {
      state.settings = settings;
      const timezone = jstz.determine().name();

      // Check timezone is allowed
      if (state.settings.widget_enabled && state.settings.whitelisted_timezones.length > 0) {
        state.settings.widget_enabled = !!_.find(state.settings.whitelisted_timezones, (tz) => {
          return tz.label === timezone;
        });
      }
      if (!state.settings.widget_enabled) {
        const timezones = state.settings.whitelisted_timezones.map((tz) => tz.label);
        console.error(`Timezone: '${timezone}' not in '${timezones.join("', '")}'`);
      }
    },
    setDealership(state, dealership,targetDealership) {
      targetDealership = Object.assign({},dealership, targetDealership) ;
      console.log(targetDealership) ;
    },
    checkRobot(state) {
      const isRobot = (userAgent) => {
        const robots = new RegExp([
          /bot/, /spider/, /crawl/, /crawler/,                            // GENERAL TERMS
          /APIs-Google/, /AdsBot/, /Googlebot/, /AdsBot-Google/,                // GOOGLE ROBOTS
          /mediapartners/, /Google Favicon/,
          /FeedFetcher/, /Google-Read-Aloud/,
          /DuplexWeb-Google/, /googleweblight/,
          /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/,        // OTHER ENGINES
          /ecosia/, /ia_archiver/,
          /facebook/, /instagram/, /pinterest/, /reddit/,       // SOCIAL MEDIA
          /slack/, /twitter/, /whatsapp/, /youtube/,
          /semrush/, /tiktok/                                         // OTHER
        ].map((r) => r.source).join("|"), "i");               // BUILD REGEXP + "i" FLAG

        return robots.test(userAgent);
      };
       // Check if the user agent is a robot
      state.robot = isRobot(window.navigator.userAgent);
    },

    setMobileMode(state, mobileMode) {
      state.mobileMode = mobileMode;
    }
  },

  actions: {
    fetchSettings({commit, rootState}) {
      return api
        .instance()
        .get("/public/v1/team", {
          params: {
            hashid: rootState.options.options.teamId,
            dealership: rootState.options.options.context.dealership,
            referer: window.location.href,
            date: Date.now()
          }
        })
        .then((resp) => {
          if (resp.data.data) {
            commit("setSettings", resp.data.data.attributes.settings);
            commit("setDealership", resp.data.data.attributes.dealership,rootState.options.options.context.dealership);
            return resp.data.data.attributes.settings;
          }
        }).catch((err) => {
          bus.$emit("connectionError", err, "Error getting team data");
          this.settings.widget_enabled = false;
        });
    },
    checkRobot({commit}) {
      commit("checkRobot");
    },
    setMobileMode({commit}, mobileMode) {
      commit("setMobileMode", mobileMode);
    }
  }
};
